export enum EMasks {
  IP_ADDRESS = 'ipAddress',
}

export const masks = {
  [EMasks.IP_ADDRESS]: '#*.#*.#*.#*.#*.#*.#*.#*.#*.#*.#*.#*',
}
